const data = {
  products: [
    {
      id: '1',
     title :'Fjallraven ',
      price: 109.95,
      image: 'https://fakestoreapi.com/img/81fPKd-2AYL._AC_SL1500_.jpg' ,
    },
    {
      id: '2',
     title :'Mens T-Shirts ',
      price: 22.3,
      image:'https://fakestoreapi.com/img/71-3HjGNDUL._AC_SY879._SX._UX._SY._UY_.jpg' ,
    },
    {
      id: '3',
     title:'Mens Cotton Jacket',
      price:55.99,
      image:'https://fakestoreapi.com/img/71li-ujtlUL._AC_UX679_.jpg'
    },
    { 
    id: '4',
    title :'Mens Casual Slim ',
    price:15.99,
   image:'https://fakestoreapi.com/img/71YXzeOuslL._AC_UY879_.jpg'
    
  },
  {
    id:'5',
    title :'John Hardy Women',
    price : 695 ,
   image:'https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg',
    
      },

     
     
   ],

};


export default data;
